import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";

var formatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
});

const Header = () => {
	const [amount, setAmount] = useState([]);

	const renewalData = useSelector((state) => state.RenewalData);
	const loading = useSelector((state) => state.LoadingMonthly);

	useEffect(() => {
		if (renewalData) {
			setAmount(renewalData.amount);
		}
	}, [renewalData]);

	return (
		<div className="estimate ">
			<div className="d-flex">
				<div className="">
					{loading ? (
						<Spinner animation="border" variant="light" />
					) : (
						<>
							<span className="monthly ">Monthly Estimate: </span>
							<span className=" monthly-total">
								{formatter.format(
									_.get(amount, `annual_with_discount_monthly_estimate`, "")
								)}
							</span>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default Header;
